import { useSelector } from 'react-redux';

/**
 * Dark mode follows Redux appSettings (same source as theme panel / profile toggle).
 * @returns {boolean} isDarkMode
 */
const useDarkMode = () => {
  return useSelector((state) => state.appSettings.appDarkMode);
};

export default useDarkMode;

